import { loadScript } from '@/features/payments/gateways/script-loader'
import type { GatewayResult } from '@/features/payments/gateways/types'

export const CASHFREE_SCRIPT = 'https://sdk.cashfree.com/js/v3/cashfree.js'

interface CashfreeInstance {
  checkout(options: { paymentSessionId: string; redirectTarget: '_modal' | '_self' | '_blank' }): Promise<{ error?: { message?: string }; redirect?: boolean; paymentDetails?: { paymentMessage?: string } }>
}
type CashfreeFactory = (config: { mode: 'sandbox' | 'production' }) => CashfreeInstance

declare global {
  interface Window {
    Cashfree?: CashfreeFactory
  }
}

/** A closed modal cannot be told from a paid one, so a completed checkout resolves `processing` and the confirm loop settles it. */
export async function openCashfree(paymentSessionId: string, environment: 'sandbox' | 'production' = 'production'): Promise<GatewayResult> {
  await loadScript(CASHFREE_SCRIPT)
  const factory = window.Cashfree
  if (!factory) return { outcome: 'failed', message: 'Payment provider unavailable' }
  const cashfree = factory({ mode: environment })
  const result = await cashfree.checkout({ paymentSessionId, redirectTarget: '_modal' })
  if (result.error) {
    const message = result.error.message ?? ''
    return /cancel|closed/i.test(message) ? { outcome: 'cancelled' } : { outcome: 'failed', message: message || 'Payment failed' }
  }
  return { outcome: 'processing' }
}
